import React, { useEffect, useState, useContext } from 'react';
import { UserDataContext } from '../../App';
import { Grid, Typography, InputAdornment, TextField, Box, useMediaQuery } from '@mui/material';
import {useTheme, styled} from '@mui/material/styles';
import { ContentBox } from "../../libs/theme";
import RefsPayout from './RefsPayout';
import RefsReferals from './RefsReferals';
import RefsIncome from './RefsIncome';
import RefsOutcome from './RefsOutcome';
import REST from '../../libs/API';
import Notice from "../main/Notice";
import { Warning, CopyIcon, ArrowDown } from '../../assets/images/icons';
import CClipboard from '../../components/CClipboard';
import { getText } from '../../libs/utils';

const MySlider = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  ".leftArrow": {
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    "svg": {
      transform: 'rotate(90deg)',
    },
  },
  ".rightArrow": {
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    "svg": {
      transform: 'rotate(-90deg)',
    },
  },
  ".disabled": {
    opacity: 0.4,
    pointerEvents: 'none'
  },
  ".MuiButton-root": {
    width: 'calc(100% - 60px)'
  }
}))

const MyTextfield = styled(TextField)(() => ({
  ".MuiInput-root": {
    padding: '12px 21px !important'
  }
}))

const Refs = () => {
  const userData = useContext(UserDataContext);
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const [activeTab, setActiveTab] = useState(0);
  const [refData, setRefData] = useState({});

  const tabs = [
    { title: getText('accRefTabCharging'), component: <RefsIncome userToken={userData.token} /> },
    { title: getText('accRefTabWithdrawal'), component: <RefsOutcome userToken={userData.token} /> },
    { title: getText('accRefTabReflist'), component: <RefsReferals userToken={userData.token} referalLink={refData.referalLink} /> }
  ];

  useEffect(() => {
    REST.getRefSystemsList(userData.token).then((data) => {
      if (data.success) {
        setRefData({ ...data.data });
      }
    });
  }, []);

  return (
    <>
      <Grid container spacing={2} sx={{ marginBottom: {xs: '20px', md: '40px'} }}>
        <Grid item md={6} xs={12}>
          <ContentBox sx={{minHeight: '225px'}}>
            <Typography variant="h4">{getText('accRefWithdrawalTitle3')}</Typography>
            {refData.withdrawalPaymentSystems
              ? <RefsPayout
                  systems={refData.withdrawalPaymentSystems}
                  userToken={userData.token}
                  currencyAmounts={refData.currencyAmounts}
                />
              : <span className="dot-spin centered"></span>
            }
          </ContentBox>
        </Grid>
        <Grid item md={6} xs={12}>
          <ContentBox>
            <Typography variant="h4">{getText('refLinkLabel')}</Typography>
            <MyTextfield
              fullWidth
              variant="standard"
              value={refData.referalLink ? `https://crypster.net${refData.referalLink}` : ''}
              InputProps={{
                endAdornment: (
                  refData.referalLink && <InputAdornment position="end">
                    <CClipboard text={`https://crypster.net${refData.referalLink}`}>
                      <Box sx={{ margin: '4px 0 0 9px' }}><CopyIcon width="24" height="24" /></Box>
                    </CClipboard>
                  </InputAdornment>
                )
              }}
            />

            <Typography variant="caption" component="div" sx={{ padding: {md: '12px 0 25px', xs: '10px 0 20px'} }}>{getText('accRefText')}</Typography>

            <Notice
              type="warning"
              icon={<Warning />}
            >{getText('accRefLinkBoxText')}</Notice>

          </ContentBox>
        </Grid>
      </Grid>

      <ContentBox sx={{ marginBottom: '20px', padding: '24px 32px 25px' }}>
        {isXS
          ? <MySlider>
            <Box
              className={`leftArrow ${activeTab == 0 && 'disabled'}`}
              onClick={() => setActiveTab(activeTab - 1)}
            >
              <ArrowDown />
            </Box>

            <Typography
              variant='tabLink'
              className='active'
              sx={{margin: 0}}
            >
              {tabs[activeTab].title}
            </Typography>

            <Box
              className={`rightArrow ${(tabs.length - 1) == activeTab && 'disabled'}`}
              onClick={() => setActiveTab(activeTab + 1)}
            >
              <ArrowDown />
            </Box>
          </MySlider>
          : tabs.map((tab, key) => (
            <Typography
              key={key}
              variant='tabLink'
              className={activeTab === key ? 'active' : ''}
              onClick={() => setActiveTab(key)}
            >{tab.title}</Typography>
          ))
        }
      </ContentBox>

      {tabs[activeTab].component}
    </>
  )
}

export default Refs